import { render, staticRenderFns } from "./ChatUserList.vue?vue&type=template&id=10c7ac52&"
import script from "./ChatUserList.vue?vue&type=script&lang=js&"
export * from "./ChatUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports